export default __webpack_public_path__ + "static/media/V120_CoC.a2572bf9.pdf";